export function useSliderSettings() {
  const settings = {
    itemsToShow: 1,
    itemsToScroll: 1,
    snapAlign: 'center',
    wrapAround: false,
    transition: 300,
    autoplay: 0,
    breakpoints: {
      // 700px and up
      700: {
        itemsToShow: 3.5,
        itemsToScroll: 3,
        snapAlign: 'center',
      },
      // 1024 and up
      1024: {
        itemsToShow: 5,
        itemsToScroll: 5,
        snapAlign: 'start',
      },
    },
    modelValue: 0,
    mouseDrag: true,
    touchDrag: true,
    pauseAutoplayOnHover: false,
    dir: 'ltr',
    i18n: {
      ariaNextSlide: 'Navigate to next slide',
      ariaPreviousSlide: 'Navigate to previous slide',
      ariaNavigateToSlide: 'Navigate to slide {slideNumber}',
      ariaGallery: 'Gallery',
      itemXofY: 'Item {currentSlide} of {slidesCount}',
      iconArrowUp: 'Arrow pointing upwards',
      iconArrowDown: 'Arrow pointing downwards',
      iconArrowRight: 'Arrow pointing to the right',
      iconArrowLeft: 'Arrow pointing to the left',
    },
  }

  return {
    settings,
  }
}
